import i18n from 'modules/core/lib/i18n'

import { TaskDefinition } from 'modules/inbox_tasks/lib/abstraction'

export const SignatureTaskDefinition: TaskDefinition<'EsignatureSignature'> = {
  taskableTypename: 'EsignatureSignature',
  getUrl: ({ info }) => {
    return info.remoteUrl ?? null
  },
  getTitle: ({ info }) => {
    const extension = info.document?.extension
    const documentFilename = extension
      ? info.document?.filename?.replace(extension, '')
      : info.document?.filename

    if (!documentFilename) {
      return i18n.t('documents.tasks.sign_no_name')
    }

    return i18n.t('documents.tasks.sign', {
      filename: documentFilename,
    })
  },
}
